module.exports = __webpack_public_path__ + "static/media/2.60853a85.jpeg";